export default "__VITE_ASSET__Nk0HjHRs__"